const styles = {
  "shaded-elevation": "_shaded-elevation_mk6q1_1"
};
export {
  styles as default
};
//# sourceMappingURL=BaseButton.module.scss.js.map
